import React, { ReactNode } from "react";
import useTheme from "evcharging/hooks/useTheme";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";

interface RetailCardLineProps {
  label: string;
  value: string | ReactNode;
}

const RatesCardLine: React.FC<RetailCardLineProps> = (props) => {
  const {
    label,
    value,
  } = props;

  const theme = useTheme();
  const classes = createStyles(theme);

  return (
    <div className={classes.root}>
      <span className={classes.label}>
        {label}
      </span>
      <strong className={classes.value}>
        {value}
      </strong>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid #E8E8E8`,
  }),
  label: css({
    color: '#59606D',
    fontSize: 13,
    lineHeight: 3,
    fontWeight: 600,
  }),
  value: css({
    fontWeight: 600,
    fontSize: 13,
    lineHeight: 3,
    color: 'black',
  }),
  infoIcon: css({
    cursor: 'pointer',
  }),
})

export default RatesCardLine;
